const INSERT_IMAGE_BUTTON = "insert-image-button";
const PLUGIN_TOOLBAR_LINK_BUTTON = "plugin-toolbar-link-button";
const PLUGIN_TOOLBAR_IMAGE_EDITOR_BUTTON = "plugin-toolbar-button-image-editor";
const ROOT = "image-viewer";
const EXPAND_BUTTON = "image-expand-button";
const SETTINGS_MODAL = "image-settings-modal";
const SETTINGS_IMAGE_PREVIEW = "settings-image-preview";
const SETTINGS_ALT_INPUT = "settings-alt-input";
const SETTINGS_DISABLE_EXPAND_TOGGLE = "settings-expand-toggle";
const SETTINGS_DISABLE_DOWNLOAD_TOGGLE = "settings-download-toggle";
const SETTINGS_SPOILER_TOGGLE = "settings-spoiler-toggle";
const SETTINGS_IS_DECORATIVE_TOGGLE = "settings-is-decorative-toggle";
export {
  EXPAND_BUTTON,
  INSERT_IMAGE_BUTTON,
  PLUGIN_TOOLBAR_IMAGE_EDITOR_BUTTON,
  PLUGIN_TOOLBAR_LINK_BUTTON,
  ROOT,
  SETTINGS_ALT_INPUT,
  SETTINGS_DISABLE_DOWNLOAD_TOGGLE,
  SETTINGS_DISABLE_EXPAND_TOGGLE,
  SETTINGS_IMAGE_PREVIEW,
  SETTINGS_IS_DECORATIVE_TOGGLE,
  SETTINGS_MODAL,
  SETTINGS_SPOILER_TOGGLE
};
//# sourceMappingURL=data-hooks.js.map
